import api from './api';

const INVENTORY_SERVICE_URL = process.env.REACT_APP_FAST_FOOD_SERVICE || '';

const inventoryService = {
    // Unidades de Medida
    getUnits: async () => {
        const response = await api.get('/api/menu/units/', { baseURL: INVENTORY_SERVICE_URL });
        return response.data.results || response.data;
    },
    createUnit: async (data) => {
        const response = await api.post('/api/menu/units/', data, { baseURL: INVENTORY_SERVICE_URL });
        return response.data;
    },
    updateUnit: async (id, data) => {
        const response = await api.patch(`/api/menu/units/${id}/`, data, { baseURL: INVENTORY_SERVICE_URL });
        return response.data;
    },
    deleteUnit: async (id) => {
        const response = await api.delete(`/api/menu/units/${id}/`, { baseURL: INVENTORY_SERVICE_URL });
        return response.data;
    },

    // Insumos
    getSupplies: async () => {
        const response = await api.get('/api/menu/supplies/', { baseURL: INVENTORY_SERVICE_URL });
        return response.data.results || response.data;
    },
    createSupply: async (data) => {
        const isFormData = data instanceof FormData;
        const response = await api.post('/api/menu/supplies/', data, { 
            baseURL: INVENTORY_SERVICE_URL,
            headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : undefined
        });
        return response.data;
    },
    updateSupply: async (id, data) => {
        const isFormData = data instanceof FormData;
        const response = await api.patch(`/api/menu/supplies/${id}/`, data, { 
            baseURL: INVENTORY_SERVICE_URL,
            headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : undefined
        });
        return response.data;
    },
    deleteSupply: async (id) => {
        const response = await api.delete(`/api/menu/supplies/${id}/`, { baseURL: INVENTORY_SERVICE_URL });
        return response.data;
    },
    importSuppliesExcel: async (formData, params = {}) => {
        const query = new URLSearchParams();
        if (params.sucursal) query.append('sucursal', params.sucursal);
        if (params.import_vendidos !== undefined) query.append('import_vendidos', params.import_vendidos);
        const qs = query.toString() ? `?${query.toString()}` : '';

        const response = await api.post(`/api/menu/supplies/import_excel/${qs}`, formData, { 
            baseURL: INVENTORY_SERVICE_URL,
            timeout: 120000,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    },
    bulkChangeSucursal: async (supplyIds, targetSucursal) => {
        const response = await api.post('/api/menu/supplies/bulk_change_sucursal/', {
            supply_ids: supplyIds,
            target_sucursal: targetSucursal
        }, { baseURL: INVENTORY_SERVICE_URL });
        return response.data;
    },
    clearInventory: async (options = {}) => {
        const response = await api.post('/api/menu/supplies/clear_inventory/', options, {
            baseURL: INVENTORY_SERVICE_URL
        });
        return response.data;
    },

    // Movimientos
    recordMovement: async (supplyId, movementData) => {
        const response = await api.post(`/api/menu/supplies/${supplyId}/record_movement/`, movementData, { baseURL: INVENTORY_SERVICE_URL });
        return response.data;
    },
    transferToUse: async (supplyId, quantity) => {
        const response = await api.post(`/api/menu/supplies/${supplyId}/transfer_to_use/`, { quantity }, { baseURL: INVENTORY_SERVICE_URL });
        return response.data;
    },
    getMovements: async () => {
        const response = await api.get('/api/menu/supply-movements/', { baseURL: INVENTORY_SERVICE_URL });
        return response.data.results || response.data;
    },
    deleteMovement: async (id) => {
        const response = await api.delete(`/api/menu/supply-movements/${id}/`, { baseURL: INVENTORY_SERVICE_URL });
        return response.data;
    },

    // Recetas (Producto -> Insumo para POS)
    getRecipeIngredients: async (productId) => {
        const params = productId ? { product: productId } : {};
        const response = await api.get('/api/menu/recipe-ingredients/', { baseURL: INVENTORY_SERVICE_URL, params });
        return response.data.results || response.data;
    },
    createRecipeIngredient: async (data) => {
        const response = await api.post('/api/menu/recipe-ingredients/', data, { baseURL: INVENTORY_SERVICE_URL });
        return response.data;
    },
    deleteRecipeIngredient: async (id) => {
        const response = await api.delete(`/api/menu/recipe-ingredients/${id}/`, { baseURL: INVENTORY_SERVICE_URL });
        return response.data;
    },

    // Recetas de Producción (Mezclas)
    getRecipes: async () => {
        const response = await api.get('/api/menu/recipes/', { baseURL: INVENTORY_SERVICE_URL });
        return response.data.results || response.data;
    },
    getRecipe: async (id) => {
        const response = await api.get(`/api/menu/recipes/${id}/`, { baseURL: INVENTORY_SERVICE_URL });
        return response.data;
    },
    createRecipe: async (data) => {
        const response = await api.post('/api/menu/recipes/', data, { baseURL: INVENTORY_SERVICE_URL });
        return response.data;
    },
    updateRecipe: async (id, data) => {
        const response = await api.put(`/api/menu/recipes/${id}/`, data, { baseURL: INVENTORY_SERVICE_URL });
        return response.data;
    },
    deleteRecipe: async (id) => {
        const response = await api.delete(`/api/menu/recipes/${id}/`, { baseURL: INVENTORY_SERVICE_URL });
        return response.data;
    },
    produceRecipe: async (id, data) => {
        const response = await api.post(`/api/menu/recipes/${id}/produce/`, data, { baseURL: INVENTORY_SERVICE_URL });
        return response.data;
    },
    getProductions: async () => {
        const response = await api.get('/api/menu/recipe-productions/', { baseURL: INVENTORY_SERVICE_URL });
        return response.data.results || response.data;
    },
};

export default inventoryService;
